@use '@lib/assets/styles/main.scss' as *;

.root {
  display: flex;
  flex-direction: column;
  z-index: 0;
  position: relative;
  color: $gray700;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: left;
}

.rootWithScroll {
  overflow: hidden;
}

.rootWithCounter {
  padding-top: 28px;
}

.rootWithLoading {
  min-height: 48px; // Loader height
}

.tableCounter {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.tableLoader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tableContainer {
  position: relative;
  overflow: auto;
  background-color: $gray0;
  flex: 1;
  &.tableContainerWithScroll {
    @include scrollStyles;
  }
  &.tableContainerWithBordered {
    border: 1px solid $gray200;
  }
  &:not(.tableContainerWithBordered) {
    border-top: 1px solid $gray100;
    border-bottom: 1px solid $gray100;
  }
  &.tableContainerWithRounded {
    &:not(.tableContainerWithTopHead) {
      &.tableContainerWithPagination {
        border-radius: 10px 10px 0 0;
      }
    }
    &:not(.tableContainerWithPagination) {
      &.tableContainerWithTopHead {
        border-radius: 0 0 10px 10px;
      }
    }
    &:not(.tableContainerWithTopHead):not(.tableContainerWithPagination) {
      border-radius: 10px;
    }
  }

  &.tableContainerWithLoading {
    @extend %disabledGrayscale;
  }
}

.table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}

.topHead {
  border-radius: 10px 10px 0 0;
  background-color: $gray0;
  border: 1px solid $gray200;
  border-bottom: none;
}

.pagination {
  background-color: $gray0;
  &.paginationWithBordered {
    border: 1px solid $gray200;
    border-top: none;
  }
  &.paginationWithRounded {
    border-radius: 0 0 10px 10px;
  }
}

.actionsRow {
  position: absolute;
  top: 1.5px;
  left: 52px;
  right: 1px;
  height: 47px;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 16px;
  background-color: $gray0;
  z-index: 2;
  border-radius: 0 10px 0 0;
}

.actionsRowWhenCounter {
  top: 29.5px
}
